// extracted by mini-css-extract-plugin
export default {"fileList":"M4MjBJ","placeholder":"Otwn3P","FileUploaderDefaultSkin":"OkRBQc","fileUploaderDefaultSkin":"OkRBQc","minHeight":"wTl2x4"};